import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActionService, { DialogActionServiceType } from "./DialogActionService";

interface DialogActionType {
  buttonName: string;
  buttonClass?: any;
  buttonVariant?: "text" | "outlined" | "contained";
  color?: any;
  title?: string;
  description: string;
  action: any;
}

export default function DialogAction(props: DialogActionType) {
  const { buttonName, buttonClass, title, description, action, buttonVariant, color } = props;
  const { openDialog, buttonAction, openDialogAction }: DialogActionServiceType = DialogActionService({ action });

  return (
    <>
      <Button
        variant={buttonVariant ?? "contained"}
        color={color ?? "primary"}
        size="small"
        className={buttonClass}
        onClick={openDialogAction}
      >
        {buttonName}
      </Button>
      <Dialog
        open={openDialog}
        onClose={buttonAction}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{description}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={buttonAction} variant="contained" color="primary" size="small">
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
